import { Typography, ListItemAvatar, Avatar, ListItem as MUIListItem } from '@mui/material';
import SvgIconStyle from '@components/SvgIconStyle';
import { FC } from 'react';
import { useStyles } from './styles';
import { ListItem as ListItemType } from '../../types';
import { DialogListJSONAPI } from '~/api/resources/dialog_list';

type Props = {
  list: DialogListJSONAPI;
  active: string | undefined;
  setActive: (id: string, listId: string) => void;
};

const ListItem: FC<Props> = ({ list, active, setActive }) => {
  const item: ListItemType = {
    id: list.id,
    shortName: list.attributes.name.match(/\b(\w)/g)?.join('') || '',
    name: list.attributes.name,
    color: list.attributes.color,
  };

  const styles = useStyles({ isActive: active === item.id, color: item.color });

  return (
    <MUIListItem
      data-role={`add-to-list-popup-list-${list.id}`}
      onClick={() => setActive(item.id, list.id)}
      key={item.id}
      sx={styles.listItem}
    >
      <ListItemAvatar>
        <Avatar sx={styles.avatar}>
          <Typography variant="body2" sx={styles.avatarText}>
            {item.shortName}
          </Typography>
        </Avatar>
      </ListItemAvatar>
      <Typography variant="body2">{item.name}</Typography>
      {active === item.id && (
        <SvgIconStyle src="/icons/check/24/solid.svg" sx={styles.activeIcon} />
      )}
    </MUIListItem>
  );
};

export default ListItem;
